// IMPORT PACKAGE REFERENCES

import { combineReducers } from "redux";
import LoginReducer from "./Reducers/LoginReducer";

export const AppReducer = combineReducers({
  LoginReducer
});
